// 首页右侧直播间人气列表（用来请求列表的人气数据）
export const GETRIGHTLIVEPOPULARITYLIST = 'get-right-live-popularity-list'
